// src/redux/sagas/index.ts
import { all, fork } from 'redux-saga/effects';
// Import your individual sagas here
import gameSaga from './gameSaga';

export default function* rootSaga() {
    yield all([
        fork(gameSaga),
    ]);
}
